import { deepAddParent as W } from "@project-rouge/rg-core";
import { useThree as G } from "@react-three/fiber";
import { useMemo as t, useRef as X, useEffect as Y, Fragment as Z } from "react";
import { Vector3 as Q, Mesh as q, BoxGeometry as b } from "three";
import { RgView as nn } from "../../3d/rg-render-types/index4.js";
import { useFunction as $ } from "../../hooks/index2.js";
import { FitToFrame as en } from "../../utils/index11.js";
import { StandardRenderLayers as on } from "../../utils/index27.js";
import { hashRgObj as tn } from "../../utils/rg-util/index5.js";
import { dispose as rn } from "../../utils/three/index.js";
import { BuildingFcLayer as sn } from "./index3.js";
import { ChildrenToMerge as cn, MergeBuildingChildrenFC as an } from "./index4.js";
import { jsx as k, Fragment as pn, jsxs as mn } from "react/jsx-runtime";
const Fn = ({
  building: s,
  visibility: d,
  focus: P,
  orbit: l,
  layers: c = on,
  addUVs: a = [],
  onClick: p,
  onContextMenu: m,
  onDoubleClick: e,
  onPointerUp: w,
  onPointerDown: h,
  onPointerOver: M,
  onPointerOut: C,
  onPointerEnter: x,
  onPointerLeave: y,
  onPointerMove: _,
  onPointerCancel: g,
  colourFunc: z
}) => {
  const D = G((n) => n.camera), H = G((n) => n.invalidate);
  t(() => {
    W(s);
  }, [s]);
  const F = t(() => s.children.filter((n) => !cn.includes(n.type)), [s]), J = t(() => {
    const n = /* @__PURE__ */ new Map();
    for (const o of F) {
      if (o.hash || (o.hash = tn(o)), n.get(o.hash))
        continue;
      const f = new nn({
        ...o,
        pos: [0, 0, 0],
        rot: [0, 0, 0]
      });
      n.set(o.hash, f);
    }
    return n;
  }, [F]), r = X({
    onClick: /* @__PURE__ */ new Map(),
    onContextMenu: /* @__PURE__ */ new Map(),
    onDoubleClick: /* @__PURE__ */ new Map(),
    onPointerUp: /* @__PURE__ */ new Map(),
    onPointerDown: /* @__PURE__ */ new Map(),
    onPointerOver: /* @__PURE__ */ new Map(),
    onPointerOut: /* @__PURE__ */ new Map(),
    onPointerEnter: /* @__PURE__ */ new Map(),
    onPointerLeave: /* @__PURE__ */ new Map(),
    onPointerMove: /* @__PURE__ */ new Map(),
    onPointerCancel: /* @__PURE__ */ new Map()
  }), E = t(() => p ? (n) => i(n, p, r.current.onClick) : void 0, [p]), B = t(() => m ? (n) => i(n, m, r.current.onContextMenu) : void 0, [m]), I = t(() => e ? (n) => i(n, e, r.current.onDoubleClick) : void 0, [e]), L = t(() => w ? (n) => i(n, w, r.current.onPointerUp) : void 0, [w]), S = t(() => h ? (n) => i(n, h, r.current.onPointerDown) : void 0, [h]), T = t(() => M ? (n) => i(n, M, r.current.onPointerOver) : void 0, [M]), j = t(() => C ? (n) => i(n, C, r.current.onPointerOut) : void 0, [C]), R = t(() => x ? (n) => i(n, x, r.current.onPointerEnter) : void 0, [x]), U = t(() => y ? (n) => i(n, y, r.current.onPointerLeave) : void 0, [y]), A = t(() => _ ? (n) => i(n, _, r.current.onPointerMove) : void 0, [_]), V = t(() => g ? (n) => i(n, g, r.current.onPointerCancel) : void 0, [g]), i = $((n, o, f) => {
    const u = n.event.timeStamp;
    let v = f.get(u);
    v || (v = [], f.set(u, v)), v.push(n), K({
      timeStamp: u,
      queueMap: f,
      handler: o
    });
  }), K = $(({
    timeStamp: n,
    queueMap: o,
    handler: f
  }) => {
    setTimeout(() => {
      const O = o.get(n);
      if (!O)
        return;
      o.delete(n);
      const u = O.sort((v, N) => v.event.distance - N.event.distance)[0];
      u.event.timeStamp = Date.now(), f(u);
    }, 0);
  });
  return Y(() => {
    !l || !P || D.isPerspectiveCamera && fn({
      building: s,
      orbit: l,
      camera: D,
      invalidate: H
    });
  }, [P, s, d, l]), /* @__PURE__ */ k(pn, {
    children: Array.from(c).map(([n, o]) => /* @__PURE__ */ mn(Z, {
      children: [/* @__PURE__ */ k(sn, {
        buildingChildren: F,
        layerID: n,
        layer: o,
        visibility: d,
        views: J,
        onClick: E,
        onContextMenu: B,
        onDoubleClick: I,
        onPointerUp: L,
        onPointerDown: S,
        onPointerOver: T,
        onPointerOut: j,
        onPointerEnter: R,
        onPointerLeave: U,
        onPointerMove: A,
        onPointerCancel: V,
        colourFunc: z
      }), /* @__PURE__ */ k(an, {
        building: s,
        layer: o,
        visibility: d,
        addUVs: a,
        onClick: E,
        onContextMenu: B,
        onDoubleClick: I,
        onPointerUp: L,
        onPointerDown: S,
        onPointerOver: T,
        onPointerOut: j,
        onPointerEnter: R,
        onPointerLeave: U,
        onPointerMove: A,
        onPointerCancel: V,
        colourFunc: z
      })]
    }, n))
  });
};
function fn({
  building: s,
  orbit: d,
  camera: P,
  invalidate: l
}) {
  const c = new Q(1 / 0, 1 / 0, 1 / 0), a = new Q(-1 / 0, -1 / 0, -1 / 0);
  for (const e of s.children)
    e.pos[0] < c.x && (c.x = e.pos[0]), e.pos[1] < c.y && (c.y = e.pos[1]), e.pos[2] < c.z && (c.z = e.pos[2]), e.pos[0] > a.x && (a.x = e.pos[0]), e.pos[1] > a.y && (a.y = e.pos[1]), e.pos[2] > a.z && (a.z = e.pos[2]);
  const p = a.clone().sub(c), m = new q(new b(p.x, p.y, p.z));
  m.position.add(p.clone().multiplyScalar(0.5)), m.scale.setScalar(1.5), en({
    target: m,
    orbit: d,
    camera: P,
    invalidate: l
  }).then(() => {
    rn(m);
  });
}
export {
  Fn as BuildingFC
};
//# sourceMappingURL=index2.js.map
